module.exports = __webpack_public_path__ + "img/kompass.795569e7.svg";